// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"a3beff18","container":"a17dbc8f","textContainer":"cbf9f586","leftContent":"f366868e","rightContent":"e0969c5a"};